'use client';

import React, { memo, useEffect, useState } from 'react';
import { MODALS } from '../../../util/constants';
import getStrapiModalInfo from '../../../util/getStrapiModalInfo';
import SweeprActionModal from '../../shared/sweepr-action-modal/SweeprActionModal';
import LoginVerificationContainer from './LoginVerificationContainer';

const { LOGIN_VERIFICATION } = MODALS;

/**
 * @name LoginVerificationModal
 * @description - Login Verification modal component
 * @param {boolean} showLoginVerificationModal - Toggle's the login verification modal
 * @returns {JSX.Element} Login Verification Modal
 */
const LoginVerificationModal = ({
  showLoginVerificationModal,
  handleAction,
  disableCTA,
  apiError,
  values,
  setValues,
  setDisableCTA,
  enableCaptchaV2,
  captchaV2,
  setCaptchaV2,
  errorCount,
  maxErrorCount,
}) => {
  const [cmsData, setCmsData] = useState(null);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    /**
     * @name getCmsData
     * @description Fetches data from the Strapi API
     * @returns {Promise<void>} Promise and sets the state cmsData when resolved
     */
    const getCmsData = async () => {
      const data = await getStrapiModalInfo(LOGIN_VERIFICATION);
      setCmsData(data);
    };
    setLoad(false);
    getCmsData();
  }, []);

  return (
    <SweeprActionModal
      id={cmsData?.attributes?.modalID}
      open={showLoginVerificationModal?.value}
      iconSrc={errorCount > 0 && cmsData?.attributes?.iconSrc?.data?.attributes?.url}
      handleClose={showLoginVerificationModal?.disable}
      handleBack={showLoginVerificationModal?.disable}
      title={errorCount === 0 && cmsData?.attributes?.title}
      description={
        <>
          {errorCount === 0 && cmsData?.attributes?.firstHalfDescription}
          <LoginVerificationContainer
            setDisableCTA={setDisableCTA}
            values={values}
            setValues={setValues}
            disableCTA={disableCTA}
            enableCaptchaV2={enableCaptchaV2}
            apiError={apiError}
            captchaV2={captchaV2}
            setCaptchaV2={setCaptchaV2}
            errorCount={errorCount}
            maxErrorCount={maxErrorCount}
            handleAction={handleAction}
          />
        </>
      }
      load={load}
      cta={errorCount === 0 && cmsData?.attributes?.cta}
      disablecta={disableCTA}
      handleAction={handleAction}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disclaimer={errorCount === 0 && cmsData?.attributes?.disclaimer}
    />
  );
};
LoginVerificationModal.displayName = 'LoginVerificationModal';
export default memo(LoginVerificationModal);
